import React, { useEffect } from 'react'
import styles from './LandingPage.module.css'
import { useParams } from 'react-router-dom'
import {ArrowLeftOutlined} from '@ant-design/icons'

function LandingPage() {
    const [tryNowURL, setTryNowURL] = React.useState<string>('')
    const { platform } = useParams<{ platform: string }>()
    const landingRoutesArray = [
        {
          platForm: 'Care Academy',
          url: import.meta.env.VITE_ACADEMY_LANDING
        },
        {
          platForm: 'Care Rota',
          url: import.meta.env.VITE_ROTA_LANDING
        },
        {
          platForm: 'Care Hires Reporting Suite',
          url: import.meta.env.VITE_REPORTING_LANDING
        }
      ]

      const goBack = (): void => {
        window.history.back()
      }

      useEffect(() => {
        if (platform) {
          const route = landingRoutesArray.find(route => route.platForm === platform);
          if (route) {
            setTryNowURL(encodeURI(route.url as string));
          }
        }
      }, [platform]);
  return (
    <div className={styles.backgroundSizeWidth}>
    <button className={styles.backButton} onClick={goBack}>
        <ArrowLeftOutlined className={styles.icon} />
    </button>
    <iframe width="100%" height="93%" frameBorder="0" src={tryNowURL}> </iframe>
        </div>
  )
}   

export default LandingPage